import { EMPTY_FIELD } from 'constants/emptyField';

import { useState } from 'react';

import { usePermissions } from 'hooks/usePermissions';
import {
  StyledCard,
  CardHeaderStyled,
} from 'pages/Orders/OrdersShow/OrdersShowCommonInfo/OrdersShowCommonInfo.styled';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useShowController } from 'react-admin';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Collapse } from 'shared/mui/Collapse/Collapse';
import { ExpandIconButton } from 'shared/mui/IconButtons';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { EmbeddedFunctionField, TextField } from 'shared/react-admin/Fields';
import { ReferenceField, ReferenceLink } from 'shared/react-admin/ReferenceFields';
import { Order } from 'types/embedded/order';
import { Permission } from 'types/embedded/permission';

import { OrdersShowCommonInfoMerchantClientField } from './OrdersShowCommonInfoMerchantClientField';

export const OrdersShowCommonInfoMerchant = (): JSX.Element => {
  const translate = useTypedTranslate();
  const { hasResourcePermissions } = usePermissions();
  const { record: order } = useShowController<Order>();

  const [isExpanded, setIsExpanded] = useState(true);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <RecordContextProvider value={order}>
      <StyledCard>
        <CardHeaderStyled
          appendActions={
            <ExpandIconButton isExpanded={isExpanded} onClick={handleExpandClick} size="small" />
          }
          title={translate('app.orders.merchantDetails')}
          titleSize="smallBold"
        />
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <CardContent sx={{ padding: '0 16px 16px !important' }}>
            <CardTable tableBodyProps={{ sx: { '& td': { width: '132px' } } }}>
              <TableRowWrapper label={translate('app.table.merchant')}>
                <ReferenceField link={false} reference="merchants" source="merchant.@id">
                  {hasResourcePermissions('merchants', [Permission.Read, Permission.Full]) ? (
                    <ReferenceLink type="show" underline="always">
                      <TextField source="name" />
                    </ReferenceLink>
                  ) : (
                    <TextField source="name" />
                  )}
                </ReferenceField>
              </TableRowWrapper>
              <TableRowWrapper label={translate('app.common.merchantAccount')}>
                <EmbeddedFunctionField sourceField="merchantAccount.name" />
              </TableRowWrapper>
              <TableRowWrapper label={translate('app.table.client')}>
                <ReferenceField
                  emptyText={translate('app.common.no')}
                  link={false}
                  reference="customers"
                  source="customer"
                >
                  <OrdersShowCommonInfoMerchantClientField />
                </ReferenceField>
              </TableRowWrapper>
              <TableRowWrapper label={translate('app.table.clientData')}>
                <ReferenceField
                  emptyText={EMPTY_FIELD}
                  link={false}
                  reference=".well-known/genid"
                  source="account.@id"
                >
                  <TextField source="account" />
                </ReferenceField>
              </TableRowWrapper>
            </CardTable>
          </CardContent>
        </Collapse>
      </StyledCard>
    </RecordContextProvider>
  );
};
